module.exports = {"@metadata":{"authors":["Aue Nai"]},"app-feedback-link":"ရီု","back-top":"ကလေင် တိုန် နူစ","error":"ဗၠေတ်","field-label-end-date":"တ္ၚဲတုဲဒှ်","field-label-start-date":"တ္ၚဲစပ္တမ်","field-label-users":"ညးလွပ်","field-label-wiki":"ဝဳကဳ","field-select-no-results":"အရာမဂၠာဲဂှ် မုဟွံဂွံ ဆဵု","discuss-on-wiki-copy":"စၠောအ်ကပ်ပဳ"}


//////////////////
// WEBPACK FOOTER
// ../i18n/mnw.json
// module id = 307
// module chunks = 0